module.exports = __webpack_public_path__ + "d15.no2.a374c536.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/stories/kanai/d15.no2.jpg
// module id = Vwev
// module chunks = 0